import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { CatSaleTypeModel } from 'src/app/model/cat-sale-type.model';
import { CatSaleTypeService } from 'src/app/services/cat-sale-type.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalCatSaleTypeComponent } from 'src/app/shared/modal-cat-sale-type/modal-cat-sale-type.component';

@Component({
  selector: 'app-cat-sale-type',
  templateUrl: './cat-sale-type.component.html',
  styleUrls: ['./cat-sale-type.component.css']
})
export class CatSaleTypeComponent implements OnInit {
  // estado pagina
  public viewStatus = 0;  // -1:nada, 0:spinner, 1:tabla
  public saleTypes: CatSaleTypeModel[] = [];

  // opciones datatables
  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width: 140, targets: -1 }
    ],
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth: false,
    paging: true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar (descripción o estado):',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private creator: CreatorService,
    private modalService: NgbModal,
    private saleTypeService: CatSaleTypeService,
    private toastr: ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add = () => {
    let saleType = this.creator.newCatSaleType();
    let modalRef = this.modalService.open(ModalCatSaleTypeComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'dark-modal' });
    modalRef.componentInstance.saleType = { ...saleType };
    modalRef.componentInstance.mode = 'create';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }
  edit = (saleType: CatSaleTypeModel) => {
    let modalRef = this.modalService.open(ModalCatSaleTypeComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'dark-modal' });
    modalRef.componentInstance.saleType = { ...saleType };
    modalRef.componentInstance.mode = 'edit';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }

  // ACTIVAR / DESACTIVAR
  deactivate = (saleType: CatSaleTypeModel) => {
    Swal.fire({
      title: '¿Desactivar tipo de venta?',
      html: 'Se desactivará <strong>' + saleType.description + '</strong>. El registro no se elimina, solo deja de estar activo.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, desactivar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const userId = Number(localStorage.getItem('com_token'));
        this.viewStatus = 0;
        this.saleTypeService.delete(saleType.saleTypeId, userId)
          .pipe(
            tap((resp: any) => {
              if (resp && resp.codeHttpStatus === 200) {
                this.toastr.success('El tipo de venta se desactivó con éxito.');
                this.getCatalogs();
              } else {
                this.viewStatus = 1;
                this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar desactivar el tipo de venta.');
              }
            }),
            catchError(error => {
              this.viewStatus = 1;
              const messageError = error && error.error && error.error.messageError;
              return of(this.toastr.error(messageError || 'Ocurrió un error al intentar desactivar el tipo de venta.'));
            })
          )
          .subscribe();
      }
    });
  }

  reactivate = (saleType: CatSaleTypeModel) => {
    Swal.fire({
      title: '¿Reactivar tipo de venta?',
      html: 'Se reactivará <strong>' + saleType.description + '</strong>.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, reactivar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const userId = Number(localStorage.getItem('com_token'));
        this.viewStatus = 0;
        const payload: CatSaleTypeModel = { ...saleType, activeId: true, modifUserId: userId };
        this.saleTypeService.save(payload)
          .pipe(
            tap((resp: any) => {
              if (resp && resp.codeHttpStatus === 200) {
                this.toastr.success('El tipo de venta se reactivó con éxito.');
                this.getCatalogs();
              } else {
                this.viewStatus = 1;
                this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar reactivar el tipo de venta.');
              }
            }),
            catchError(error => {
              this.viewStatus = 1;
              const messageError = error && error.error && error.error.messageError;
              return of(this.toastr.error(messageError || 'Ocurrió un error al intentar reactivar el tipo de venta.'));
            })
          )
          .subscribe();
      }
    });
  }

  // INFO
  getCatalogs = () => {
    this.saleTypeService.getAll()
      .pipe(
        tap((resp: any) => {
          this.saleTypes = resp.data || [];
          this.viewStatus = 1;
        }),
        catchError(error => {
          this.viewStatus = -1;
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de tipos de venta.'));
        })
      )
      .subscribe();
  }
}
